import { render, staticRenderFns } from "./TopicoJaleklinico.vue?vue&type=template&id=41587172&"
import script from "./TopicoJaleklinico.vue?vue&type=script&lang=js&"
export * from "./TopicoJaleklinico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports